export function LoadingSkeleton({ height = 'h-56' }: { height?: string }) {
  return <div className={`${height} bg-neutral-100 rounded-lg animate-pulse`} />
}

export function EmptyState({ message = 'No data available yet.' }: { message?: string }) {
  return (
    <div className="h-56 flex flex-col items-center justify-center text-center text-neutral-400 gap-2">
      <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
        <path d="M21 8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16Z" />
        <path d="m3.3 7 8.7 5 8.7-5M12 22V12" />
      </svg>
      <p className="text-sm">{message}</p>
    </div>
  )
}

export function ErrorState({ message }: { message: string }) {
  return (
    <div className="h-56 flex flex-col items-center justify-center text-center text-red-400 gap-2">
      <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
        <circle cx="12" cy="12" r="10" />
        <line x1="12" y1="8" x2="12" y2="12" />
        <line x1="12" y1="16" x2="12.01" y2="16" />
      </svg>
      <p className="text-sm">{message}</p>
    </div>
  )
}

const STATUS_STYLES: Record<'ok' | 'warn' | 'critical' | 'unknown', { bg: string; text: string; dot: string; label: string }> = {
  ok: { bg: 'bg-emerald-50', text: 'text-emerald-700', dot: 'bg-emerald-500', label: 'Healthy' },
  warn: { bg: 'bg-amber-50', text: 'text-amber-700', dot: 'bg-amber-500', label: 'Elevated' },
  critical: { bg: 'bg-red-50', text: 'text-red-700', dot: 'bg-red-500', label: 'Critical' },
  unknown: { bg: 'bg-neutral-100', text: 'text-neutral-500', dot: 'bg-neutral-400', label: 'Unknown' },
}

export function thresholdStatus(percent: number | null | undefined, warnAt = 70, criticalAt = 90): keyof typeof STATUS_STYLES {
  if (percent == null) return 'unknown'
  if (percent >= criticalAt) return 'critical'
  if (percent >= warnAt) return 'warn'
  return 'ok'
}

export function StatusPill({ status }: { status: keyof typeof STATUS_STYLES }) {
  const s = STATUS_STYLES[status]
  return (
    <span className={`inline-flex items-center gap-1.5 text-xs font-medium px-2 py-0.5 rounded-full ${s.bg} ${s.text}`}>
      <span className={`w-1.5 h-1.5 rounded-full ${s.dot} ${status === 'critical' ? 'animate-pulse' : ''}`} />
      {s.label}
    </span>
  )
}
